import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { fs } from '../utils/typography';

const chromeButtonStyle = (tc) => ({
    width: 30,
    height: 30,
    borderRadius: 8,
    border: `1px solid ${tc.gridLine}`,
    color: tc.muted,
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 0,
});

/** Toggle between normal and large text sizing. */
const TextScaleToggle = ({ className = '', compact = false }) => {
    const { theme, textScale, toggleTextScale } = useTheme();
    const tc = theme.tokens.colors;
    const isLarge = textScale === 'large';

    if (compact) {
        return (
            <button
                type="button"
                onClick={toggleTextScale}
                className={`rounded-lg h-8 w-8 flex items-center justify-center ${theme.viewButtonInactive} ${className}`}
                aria-label={isLarge ? 'Switch to normal text size' : 'Switch to large text size'}
                title={isLarge ? 'Normal text' : 'Large text'}
                aria-pressed={isLarge}
            >
                <span style={{ fontFamily: theme.tokens.fonts.ui, fontSize: fs(isLarge ? 15 : 13), fontWeight: 700, lineHeight: 1 }} aria-hidden="true">A</span>
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={toggleTextScale}
            className={`flex items-center justify-center ${className}`}
            style={chromeButtonStyle(tc)}
            aria-label={isLarge ? 'Switch to normal text size' : 'Switch to large text size'}
            title={isLarge ? 'Normal text' : 'Large text'}
            aria-pressed={isLarge}
        >
            <span style={{ fontFamily: theme.tokens.fonts.ui, fontSize: fs(isLarge ? 16 : 13), fontWeight: 700, lineHeight: 1 }} aria-hidden="true">A</span>
        </button>
    );
};

export default TextScaleToggle;
